import { DataColumn, StateTrackedData } from "@src/common/domain/common.model";
import { State } from "@headlessui/react/dist/internal/open-closed";
import { formatDDMMYYYY } from "@src/utils/formate-date";

export enum UserRole {
  ADMIN = "ADMIN",
  CREATOR = "CREATOR",
  HOS = "HOS",
  HOD = "HOD",
  USER = "USER",
}

export type CustomTaskTableProps={
  task:any[];
}


export type ApprovalPayload = {
  ids: string[];
  user_id: string;
  remarks?: string;
};
export const taskTableHeaders: DataColumn[] = [
  {
    key: "name",
    label: "NAME",
  },
  {
    key: "departmentName",
    label: "DEPARTMENT",
  },
  {
    key: "userName",
    label: "RESPONSIBILITY",
  },
  {
    key: "submissionDate",
    label: "PLAN SUBMISSION DATE",
    format: (value: any) => {
      if(value === undefined || value === null || value.length === 0){
        return "";
      }
      return formatDDMMYYYY(value);
    }
  },
  {
    key: "startDate",
    label: "START DATE",
    format: (value: any) => {
      if(value === undefined || value === null || value.length === 0 ){
        return "";
      }
      if(value === "NA" || value === "N/A" || value === "-"){
        return value;
      }
      return formatDDMMYYYY(value);
    },
    classes: (row:TaskModelRef)=>{
      if(row.isNotApplicable){
        return "text-main-600 font-bolder"
      }
      return "";
    }
  },
  {
    key: "endDate",
    label: "END DATE",
    format: (value: any) => {
      if(value === undefined || value === null || value.length === 0){
        return "";
      }
      return formatDDMMYYYY(value);
    }
  },
  {
    key: "progress",
    label: "PROGRESS",
    classes: (row:TaskModelRef)=>{
      if(row.actionStatus === "DELAYED"){
        return "text-red-600 font-bolder !text-center bg-red-400 bg-opacity-10 rounded-lg px-2 py-1 border border-red-600"
      }else if(row.actionStatus === "IN_PROGRESS"){
        return "text-green-600 font-bold !text-center bg-green-400 bg-opacity-10 rounded-lg px-2 py-1 border border-green-600";
      }else if(row.actionStatus === "COMPLETED"){
        return "text-gray-600 font-bold !text-center bg-gray-400 bg-opacity-10 rounded-lg px-2 py-1 border border-gray-600";
      }
      return "text-orange-600 font-bold !text-center bg-orange-400 bg-opacity-10 rounded-lg px-2 py-1 border border-orange-600";
    },
    format: (value: any) => {
      return value ? `${value}%` : "0%";
    }
  },
  {
    key: "dueDate",
    label: "Due Date",
    format: (value: any) => {
      if(value === undefined || value === null || value.length === 0){
        return "";
      }
      return formatDDMMYYYY(value);
    }
  },
  {
    key: "actionStatus",
    label: "STATUS",
    classes: (row:TaskModelRef)=>{
      if(row.actionStatus === "DELAYED"){
        return "text-red-600 font-bolder text-center bg-red-400 bg-opacity-10 rounded-lg px-2 py-1 border border-red-600"
        }else if(row.actionStatus === "IN_PROGRESS"){
        return "text-green-600 font-bold text-center bg-green-400 bg-opacity-10 rounded-lg px-2 py-1 border border-green-600";
      }else if(row.actionStatus === "COMPLETED"){
        return "text-gray-600 font-bold text-center bg-gray-400 bg-opacity-10 rounded-lg px-2 py-1 border border-gray-600";
      }
      return "text-orange-600 font-bold text-center bg-orange-400 bg-opacity-10 rounded-lg px-2 py-1 border border-orange-600";
    },
    format: (value: string) => {
      return value ? value.replace("_", " ") : "";
    }
  },
  {
    key:"statusValue",
    label:"Current State",
    format: (value: string) => {
      return value ? value.replace("_", " ") : "";
    }
  }
];
export const creatorTaskTableHeaders: DataColumn[] = [
  {
    key: "name",
    label: "NAME",
  },
  {
    key: "departmentName",
    label: "DEPARTMENT",
  },
  {
    key: "userName",
    label: "RESPONSIBILITY",
  },
  {
    key: "startDate",
    label: "START DATE",
    format: (value: any) => {
      if(value === undefined || value === null || value.length === 0){
        return "";
      }
      if(value.trim() === "NA" || value.trim() === "N/A" || value.trim() === "-"){
        return value;
      }
      return formatDDMMYYYY(value);
    },
    classes: (row:TaskModelRef)=>{
      if(row.isNotApplicable){
        return "text-main-600 font-bolder"
      }
      return "";
    }
  },
  {
    key: "endDate",
    label: "END DATE",
    format: (value: any) => {
      if(value === undefined || value === null || value.length === 0){
        return "";
      }
      return formatDDMMYYYY(value);
    }
  },
  {
    key: "progress",
    label: "PROGRESS",
    classes: (row:TaskModelRef)=>{
      if(row.actionStatus === "DELAYED"){
        return "text-red-600 font-bolder !text-center bg-red-400 bg-opacity-10 rounded-lg px-2 py-1 border border-red-600"
      }else if(row.actionStatus === "IN_PROGRESS"){
        return "text-green-600 font-bold !text-center bg-green-400 bg-opacity-10 rounded-lg px-2 py-1 border border-green-600";
      }else if(row.actionStatus === "COMPLETED"){
        return "text-gray-600 font-bold !text-center bg-gray-400 bg-opacity-10 rounded-lg px-2 py-1 border border-gray-600";
      }
      return "text-orange-600 font-bold !text-center bg-orange-400 bg-opacity-10 rounded-lg px-2 py-1 border border-orange-600";
    },
    format: (value: any) => {
      return value ? `${value}%` : "0%";
    }
  },
  {
    key: "dueDate",
    label: "Due Date",
    format: (value: any) => {
      if(value === undefined || value === null || value.length === 0){
        return "";
      }
      return formatDDMMYYYY(value);
    }
  },
  {
    key: "actionStatus",
    label: "STATUS",
    classes: (row:TaskModelRef)=>{
      if(row.actionStatus === "DELAYED"){
        return "text-red-600 font-bolder text-center bg-red-400 bg-opacity-10 rounded-lg px-2 py-1 border border-red-600"
      }else if(row.actionStatus === "IN_PROGRESS"){
        return "text-green-600 font-bold text-center bg-green-400 bg-opacity-10 rounded-lg px-2 py-1 border border-green-600";
      }else if(row.actionStatus === "COMPLETED"){
        return "text-gray-600 font-bold text-center bg-gray-400 bg-opacity-10 rounded-lg px-2 py-1 border border-gray-600";
      }
      return "text-orange-600 font-bold text-center bg-orange-400 bg-opacity-10 rounded-lg px-2 py-1 border border-orange-600";
    },
    format: (value: string) => {
      return value ? value.replace("_", " ") : "";
    }
  },
  {
    key:"statusValue",
    label:"Current State",
    format: (value: string) => {
      return value ? value.replace("_", " ") : "";
    }
  }
];
export const hodTableHeaders: DataColumn[] = [
  {
    key: "name",
    label: "NAME",
  },
  {
    key: "applicability",
    label: "APPLICABILITY",
  },
  {
    key: "departmentName",
    label: "DEPARTMENT",
  },
  {
    key: "userName",
    label: "RESPONSIBILITY",
  },
  {
    key: "startDate",
    label: "START DATE",
    format: (value: any) => {
      if(value === undefined || value === null || value.length === 0){
        return "";
      }
      if(value.trim() === "NA" || value.trim() === "N/A" || value.trim() === "-"){
        return value;
      }
      return formatDDMMYYYY(value);
    },
    classes: (row:TaskModelRef)=>{
      if(row.isNotApplicable){
        return "text-main-600 font-bolder"
      }
      return "";
    }
  },
  {
    key: "endDate",
    label: "END DATE",
    format: (value: any) => {
      if(value === undefined || value === null || value.length === 0){
        return "";
      }
      return formatDDMMYYYY(value);
    }
  },
  {
    key: "progress",
    label: "PROGRESS",
    classes: (row:TaskModelRef)=>{
      if(row.actionStatus === "DELAYED"){
        return "text-red-600 font-bolder text-center bg-red-400 bg-opacity-10 rounded-lg px-2 py-1 border border-red-600"
      }else if(row.actionStatus === "IN_PROGRESS"){
        return "text-green-600 font-bold text-center bg-green-400 bg-opacity-10 rounded-lg px-2 py-1 border border-green-600";
      }else if(row.actionStatus === "COMPLETED"){
        return "text-gray-600 font-bold text-center bg-gray-400 bg-opacity-10 rounded-lg px-2 py-1 border border-gray-600";
      }
      return "text-orange-600 font-bold text-center bg-orange-400 bg-opacity-10 rounded-lg px-2 py-1 border border-orange-600";
    },
    format: (value: any) => {
      return value ? `${value}%` : "0%";
    }
  },

];
export const revisedTaskTableHeaders: DataColumn[] = [
  {
    key: "name",
    label: "NAME",
  },
  {
    key: "departmentName",
    label: "DEPARTMENT",
  },
  {
    key: "userName",
    label: "RESPONSIBILITY",
  },
  {
    key: "submissionDate",
    label: "PLAN SUBMISSION DATE",
    format: (value: any) => {
      if(value === undefined || value === null || value.length === 0){
        return "";
      }
      return formatDDMMYYYY(value);
    }
  },
  {
    key: "startDate",
    label: "START DATE",
    format: (value: any) => {
      if(value === undefined || value === null || value.length === 0 ){
        return "";
      }
      if(value === "NA" || value === "N/A" || value === "-"){
        return value;
      }
      return formatDDMMYYYY(value);
    },
    classes: (row:TaskModelRef)=>{
      if(row.isNotApplicable){
        return "text-main-600 font-bolder"
      }
      return "";
    }
  },
  {
    key: "endDate",
    label: "END DATE",
    format: (value: any) => {
      if(value === undefined || value === null || value.length === 0){
        return "";
      }
      return formatDDMMYYYY(value);
    }
  },
  {
    key: "progress",
    label: "PROGRESS",
    classes: (row:TaskModelRef)=>{
      if(row.actionStatus === "DELAYED"){
        return "text-red-600 font-bolder !text-center bg-red-400 bg-opacity-10 rounded-lg px-2 py-1 border border-red-600"
      }else if(row.actionStatus === "IN_PROGRESS"){
        return "text-green-600 font-bold !text-center bg-green-400 bg-opacity-10 rounded-lg px-2 py-1 border border-green-600";
      }else if(row.actionStatus === "COMPLETED"){
        return "text-gray-600 font-bold !text-center bg-gray-400 bg-opacity-10 rounded-lg px-2 py-1 border border-gray-600";
      }
      return "text-orange-600 font-bold !text-center bg-orange-400 bg-opacity-10 rounded-lg px-2 py-1 border border-orange-600";
    },
    format: (value: any) => {
      return value ? `${value}%` : "0%";
    }
  },
  {
    key: "dueDate",
    label: "Due Date",
    format: (value: any) => {
      if(value === undefined || value === null || value.length === 0){
        return "";
      }
      return formatDDMMYYYY(value);
    }
  },
  {
    key: "actionStatus",
    label: "STATUS",
    classes: (row:TaskModelRef)=>{
      if(row.actionStatus === "DELAYED"){
        return "text-red-600 font-bolder text-center bg-red-400 bg-opacity-10 rounded-lg px-2 py-1 border border-red-600"
      }else if(row.actionStatus === "IN_PROGRESS"){
        return "text-green-600 font-bold text-center bg-green-400 bg-opacity-10 rounded-lg px-2 py-1 border border-green-600";
      }else if(row.actionStatus === "COMPLETED"){
        return "text-gray-600 font-bold text-center bg-gray-400 bg-opacity-10 rounded-lg px-2 py-1 border border-gray-600";
      }
      return "text-orange-600 font-bold text-center bg-orange-400 bg-opacity-10 rounded-lg px-2 py-1 border border-orange-600";
    },
    format: (value: string) => {
      return value ? value.replace("_", " ") : "";
    }
  },
  {
    key:"statusValue",
    label:"Current State",
    format: (value: string) => {
      return value ? value.replace("_", " ") : "";
    }
  }
  ];
export const customTaskStatusObject: Record<
   "HOS_APPROVED" | "HOD_SUBMITTED" | "HOD_APPROVED" | "IN_PROGRESS"| "HOS_SUBMITTED"|"CREATOR_SUBMITTED"|"TO_BE_STARTED"| "UNDER_CHECKER_REVIEW" | "UNDER_APPROVER_REVIEW" | "CHECKER_APPROVED" | "MANAGER_APPROVED" | "MANAGER_SUBMITTED",
   string
 > = {
   HOS_APPROVED: "APPROVED BY THE OWNER",
   HOS_SUBMITTED: "SUBMITTED TO ITS OWNER",
   HOD_SUBMITTED: "UNDER CHECKER REVIEW",
   HOD_APPROVED: "APPROVED BY APPROVER",
   IN_PROGRESS: "IN PROGRESS",
   CREATOR_SUBMITTED:"SUBMITTED TO CREATOR",
   TO_BE_STARTED:"TO BE STARTED",
   UNDER_CHECKER_REVIEW:"UNDER CHECKER REVIEW",
   UNDER_APPROVER_REVIEW:"UNDER APPROVER REVIEW",
   CHECKER_APPROVED:"APPROVED BY CHECKER",
   MANAGER_APPROVED:"APPROVED BY MANAGER",
   MANAGER_SUBMITTED:"SUBMITTED TO MANAGER",
 };

 export const statusObject: Record<
   "HOS_APPROVED" | "HOD_SUBMITTED" | "HOD_APPROVED" | "IN_PROGRESS"| "HOS_SUBMITTED"|"CREATOR_SUBMITTED"|"TO_BE_STARTED"|"NOT_APPLICABLE",
   string
 > = {
   HOS_APPROVED: "APPROVED BY HOS",
   HOS_SUBMITTED: "SUBMITTED TO HOS",
   HOD_SUBMITTED: "SUBMITTED TO HOD",
   HOD_APPROVED: "APPROVED BY HOD",
   IN_PROGRESS: "IN PROGRESS",
   CREATOR_SUBMITTED:"SUBMITTED TO CREATOR",
   TO_BE_STARTED:"TO BE STARTED",
     NOT_APPLICABLE : "NOT APPLICABLE"


 };

 export enum TASK_ACTION_STATUS {
   PENDING= "PENDING",
   PLANNED = "PLANNED",
   IN_PROGRESS = "IN_PROGRESS",
   DELAYED = "DELAYED",
   COMPLETED = "COMPLETED",}

export enum TASK_STATUS {
  PENDING = "PENDING",
  PLANNED = "PLANNED",
  HOS_SUBMITTED = "HOS_SUBMITTED",
    NOT_APPLICABLE = "NOT_APPLICABLE",

  IN_PROGRESS = "IN_PROGRESS",
  DELAYED = "DELAYED",
  COMPLETED = "COMPLETED",
  HOS_APPROVED = "HOS_APPROVED",
  CREATOR_SUBMITTED="CREATOR_SUBMITTED",
  UNDER_CHECKER_REVIEW="UNDER_CHECKER_REVIEW",
  CHECKER_APPROVED="CHECKER_APPROVED",
  UNDER_APPROVER_REVIEW="UNDER_APPROVER_REVIEW",
  HOD_SUBMITTED = "HOD_SUBMITTED",
  HOD_APPROVED = "HOD_APPROVED",
  HOD_REJECTED = " HOD_REJECTED",
  REJECTED = "REJECTED",
  APPROVED = "APPROVED",
  MANAGER_APPROVED = "MANAGER_APPROVED",
  MANAGER_SUBMITTED = "MANAGER_SUBMITTED",}

export enum ActionType {
  ASSIGN,
  STATUS_UPDATE,
}

export interface BulkTaskUpdateModel {
  projectId?: string;
  projectType?: string;
  taskIds: string[];
  userId?: string;
  submissionDate?: string;
  status?: string;
  remarks?: string;
  action: "assign" | "status-update";
}
export enum TaskType {
    ACTIVITY, ROOT_TASK, SUBTASK
}


export interface TaskInfo  {
  projectType: any;
  projectId: any;
  id: string;
  name?: string;
  sequenceOrder?: string;
  description?: string;
  submissionDate?: string;
  managerId?: string;
  userId?: string;
  userName?: string;
  duration?:number;
  progress?:number;
  departmentId?: string;
  departmentName?: string;
  startDate?: string;
  endDate?: string;
  actualStartDate?: string;
  actualEndDate?: string;
  revisedEndDate?: string;
  revisedStartDate?: string;
  revisedDuration?: number;
  plannedEndDate?: string;
  plannedStartDate?: string;
  parentTaskId?: string;
  status?: TASK_STATUS;
  approvalStatus?: TASK_STATUS;
  actionStatus?: TASK_ACTION_STATUS;
  taskType?: TaskType;
  subtasks?: TaskInfo[];
  dependencies?: DependencyModelRef[];
  isTaskRevisionOn?: boolean;
  modifiedType?: "SNAPSHOT"|"NEW"|"MODIFIED";
  }

export interface TaskModelRef {
  actualEndDate: null;
  actualStartDate: string;
  id: string;
  name?: string;
  departmentId?: string;
  departmentName?: string;
  parentTask: string;
  parentTaskName?: string;
  dependentTask?: string;
  startDate?: string;
  duration?: string;
  endDate?: string;
  nextUpdatedOn?: string;
  status?: TASK_STATUS;
  approvalStatus?: TASK_STATUS;
actionStatus?: TASK_ACTION_STATUS;
  statusValue?:string;
  userId?: string;
  managerId?: string;
  creatorId?: string;

  userName?: string;
  planSubmissionDate?: string;
  description?:string;
  subtasks: TaskModelRef[];
  dependencies?: DependencyModelRef[];
  taskType?: "ROOT_TASK" | "SUBTASK" | "ACTIVITY" | "TASK";
  remarks?:string
  projectId?:string
  projectType?:string
  isNotApplicable?:boolean
  isTaskRevisionOn?:boolean;
  modifiedType?: "SNAPSHOT"|"NEW"|"MODIFIED";
}

export interface DependencyModelRef {
  id: string;
  sourceTaskName?: string;
  sourceTaskId: string;
  targetTaskName?: string;
  targetTaskId: string;
  dependencyType: string;
  dependencyName?: string;
  dependency_between?: string;
}

export interface TaskRevisionModelRef {
  taskId: string;
  name: string;
  description: string;
  submissionDate: string;
  startDate: string;
  endDate: string;
  plannedStartDate: string;
  plannedEndDate: string;
  revisedStartDate: string;
  revisedEndDate: string;
  actualStartDate: string;
  actualEndDate: string;
  duration: string;
  versionNumber: string;
  type: string;
  taskStatus: string;
  approvalStatus: TASK_STATUS;
  actionStatus: TASK_ACTION_STATUS;
  path: string;
  id: string;
  status: string;
  created_on: string;
  updated_on: string;
  deleted_on: string;
  created_by: string;
  updated_by: string;
  deleted_by: string;
  version: number;
}

export type TaskStore = {
  tree: StateTrackedData<TaskInfo[]>;
  minimal: StateTrackedData<any[]>;
  info: StateTrackedData<any>;
  revisions: StateTrackedData<TaskRevisionModelRef[]>;
  dependencies: StateTrackedData<DependencyModelRef[]>;
};

export const STATUS_RANKING: TASK_STATUS[] = [
  TASK_STATUS.PENDING,
  TASK_STATUS.PLANNED,
  TASK_STATUS.HOS_SUBMITTED,
  TASK_STATUS.HOS_APPROVED,
  TASK_STATUS.MANAGER_SUBMITTED,
  TASK_STATUS.MANAGER_APPROVED,
  TASK_STATUS.CREATOR_SUBMITTED,
  TASK_STATUS.UNDER_CHECKER_REVIEW,
  TASK_STATUS.CHECKER_APPROVED,
  TASK_STATUS.UNDER_APPROVER_REVIEW,
  TASK_STATUS.HOD_SUBMITTED,
  TASK_STATUS.HOD_APPROVED,
  TASK_STATUS.APPROVED,
  TASK_STATUS.IN_PROGRESS,
  TASK_STATUS.DELAYED,
  TASK_STATUS.COMPLETED
];

export const getStatusRank = (status: TASK_STATUS):number=>{
  const rank = STATUS_RANKING.indexOf(status);
  return rank !== -1 ? rank : Infinity;
}

export const areAllStatusesGreaterThanOrEqual = (statuses: TASK_STATUS[], compareStatus: TASK_STATUS): boolean => {
  const compareRank = getStatusRank(compareStatus);
  return statuses.every(status => getStatusRank(status) >= compareRank);
};

export const actionConditions = {
  canAssign: (rowData:TaskModelRef)=> { 
    const statusRank = rowData.status ? getStatusRank(rowData.status) : Infinity;
    return statusRank >= getStatusRank(TASK_STATUS.PENDING) && 
           statusRank <= getStatusRank(TASK_STATUS.DELAYED);
  },
  canEdit: (rowData:TaskModelRef)=> { 
    const statusRank = rowData.status ? getStatusRank(rowData.status) : Infinity;
    return statusRank <= getStatusRank(TASK_STATUS.IN_PROGRESS) && 
           rowData.status != TASK_STATUS.PENDING
  },
  canView: (rowData: TaskModelRef) => { 
    const statusRank = rowData.status ? getStatusRank(rowData.status) : Infinity;
    return statusRank <= getStatusRank(TASK_STATUS.COMPLETED) 
  },
  canSubmit: (rowData: TaskModelRef) =>(rowData:TaskModelRef)=> { 
    const statusRank = rowData.status ? getStatusRank(rowData.status) : Infinity;
    return statusRank <= getStatusRank(TASK_STATUS.PLANNED) 
  },

}